const $body = $('body')
const $htmlbody = $('html, body')

function getHeaderOffset() {
	const $header = $('.header:visible').first()
	if (!$header.length) {
		return 0
	}

	return $header.outerHeight() || 0
}

$('.scroll-to').on('click', function (e) {
	e.preventDefault()
	var scrollTarget = $(this).data('target')
	var nextScrollTop = null

	if ($('body').hasClass('nav-is-visible')) {
		$('body').removeClass('nav-is-visible')
	}

	if ($.isNumeric(scrollTarget)) {
		nextScrollTop = Number(scrollTarget)
	} else {
		var $target = $('#' + scrollTarget)
		if (!$target.length) {
			$target = $('.' + scrollTarget).first()
		}

		if ($target.length) {
			nextScrollTop = $target.offset().top - getHeaderOffset() - 24
		}
	}

	if ($.isNumeric(nextScrollTop)) {
		$htmlbody.stop().animate({ scrollTop: Math.max(0, nextScrollTop) }, 500, 'swing', function () {})
	}
})

var $docHeight = $(document).height()
var $winHeight = $(window).height()
var prevScrollpos = window.pageYOffset

/*var resizeTimer;*/

/*$(window).on('resize', function(e) {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function() {
    $docHeight = $(document).height();
  }, 250);
});*/

$(window).scroll(function () {
	var scrollPos = $(document).scrollTop()
	var currentScrollPos = window.pageYOffset

	if (scrollPos >= 250) {
		if (prevScrollpos > currentScrollPos) {
			$body.removeClass('header--is-reduced')
		} else {
			$body.addClass('header--is-reduced')
			//$body.removeClass('mobilenav--isvisible');

			/*$('body').removeClass('mobilenav--isvisible');
     $('.nav--main > ul > li').removeClass('lvl-2');
     $('.nav--main').removeClass('nav--main--lvl-2');
     $('.header').removeClass('header--lvl-2');

     $('.nav--main > ul > li').removeClass('lvl-3');
     $('.nav--main').removeClass('nav--main--lvl-3');
     $('.header').removeClass('header--lvl-3');*/
		}
	}

	if (scrollPos >= 350) {
		$body.addClass('sidebar--is-visible')
	} else {
		$body.removeClass('sidebar--is-visible')
	}

	//if(scrollPos >= ($docHeight-$winHeight-1200)){
	/*if(scrollPos >= 1000){
     $body.addClass('scroll-up--is-visible');
   }else{
    $body.removeClass('scroll-up--is-visible');
  }*/

	prevScrollpos = currentScrollPos
})
